import React, { useEffect, useState } from "react";
import "./Features.scss";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useParams } from "react-router-dom";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import logger from "../../../utils/logger.js";
import Image from "../../Elements/Image/Image.tsx";
import FeaturesPageComponent from "./FeaturesPageComponent.js";
import config from "config";
import FeaturesNew from "../Features_new/index.tsx";

const FeatureItem = ({ itemName, state }) => {
  const { getLanguageCulture, getDirection } = useContent();
  const path = state[itemName].service_image.split(".")[0];
  const [hover, setHover] = useState(false);
  return (
    <a
      className="link-features-item"
      href={`/${getLanguageCulture().substring(0, 2)}/features/${itemName}`}
    >
      <div
        className="features-item"
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        <div className="feature-item-icon">
          <Image
            xxxl="true"
            name={`features/${path}${hover ? "-white" : ""}`}
            ext="png"
            className="features-category-icon"
          />
        </div>
        <div className="features-item-title">
          <h3>{state[itemName].service_category_title}</h3>
        </div>
        <div className="features-item-text">
          <p>{state[itemName].service_short_description}</p>
        </div>
        <div
          className={`ref-features-container ${
            getDirection() === "rtl" ? "ref-features-rtl" : ""
          }`}
        >
          <div>+</div>
        </div>
      </div>
    </a>
  );
};

const Features = () => {
  const { getLanguageCulture, getTextByKey, getPageText, getPath } =
    useContent();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({});
  const fetchFeaturesList = async () => {
    setLoading(true);
    const response = await apiRequest("Contents", "GetAllServices", {
      culture: getLanguageCulture(),
      forHomePage: false,
      useCache: false,
    });
    if (response.status === "success") {
      setState(response.data);
      if (params.featuresPage && params.featuresPage !== undefined) {
        if (
          response.data[params.featuresPage] === undefined ||
          !response.data[params.featuresPage]
        ) {
          //TODO: redirect to 404 page
          //get full error page url
          const errorPage = config.baseurl + getPath() + "error";
          window.location.href = errorPage;
        }
      }
      setLoading(false);
    } else {
      logger(
        "ContentFactory",
        "fetchSupportQuestionsList",
        `unable to fetch support Support Questions List`
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeaturesList();
  }, []);

  return params.featuresPage ? (
    <FeaturesPageComponent myprops={state} isSkeleton={loading} />
  ) : (
    <FeaturesNew />
    // <div
    //   className={`features-page-wrapper ${
    //     getPageText().Page_Culture
    //       ? getPageText().Page_Culture === "en-US"
    //         ? "simple-pages-ltr"
    //         : ""
    //       : ""
    //   }`}
    // >
    //   <div className="features-wrapper">
    //     <div className="features-title">
    //       <h1>{getTextByKey("features-page-title")}</h1>
    //       <div className="title-divider"></div>

    //       <p>{getTextByKey("features-page-text")} </p>
    //     </div>
    //     <div className="features-container">
    //       {!loading ? (
    //         Object.keys(state).map((itemName) => (
    //           <FeatureItem itemName={itemName} state={state} key={itemName} />
    //         ))
    //       ) : (
    //         <div className="features-loading">
    //           <Image
    //             className="loader-animation-gif"
    //             name="preloader"
    //             ext="gif"
    //             alt=""
    //             title=""
    //           />
    //         </div>
    //       )}
    //     </div>
    //   </div>
    // </div>
  );
};

export default Features;
